<template>
  <f-box 
    class="mandate-list-item margin-bottom-3"
    grid
  >
    <div class="is-col-3">
      <p>
        <small>
          <a 
            :href="mandateUrl" 
            class="color-text" 
            target="_blank"
          >
            {{ mandate.reference }}
          </a>
        </small>
      </p>
    </div>

    <div class="is-col-3 is-overflow-hidden">
      <p class="is-ellipsis">
        <small>
          <b>
            {{ mandate.bank_account.name }}
          </b>
        </small>
      </p>
    </div>

    <div class="is-col-2 is-overflow-hidden">
      <p class="is-ellipsis">
        <small>
          <b>
            {{ formatDate(mandate.next_possible_charge_date) }}
          </b>
        </small>
      </p>
    </div>

    <div class="is-col-2">
      <p class="is-ellipsis">
        <small>
          <b>
            {{ status }}
          </b>
        </small>
      </p>
    </div>

    <div class="is-col-1">
      <p class="is-ellipsis">
        <small>
          <b>
            {{ scheme }}
          </b>
        </small>
      </p>
    </div>

    <div class="is-col-1">
      <p class="is-ellipsis">
        <small v-if="mandate.is_default">
          <i class="uil uil-check"></i>
        </small>
      </p>
    </div>
  </f-box>
</template>

<script>
  import { ref, computed, watch } from 'vue'
  import useDate from '@composables/use-date'
  import Constants from '@freebe/sdk/constants'
  
  export default {
    props: {
      mandate: {
        type: Object,
        required: true,
      },

      selectable: {
        type: Boolean, 
        default: true,
      },

      isSelected: {
        type: Boolean, 
        default: false,
      },
    },

    setup (props, context) {
      const selected = ref(!!props.selected)
      const mandateUrl = computed(() =>
        `https://manage.gocardless.com/mandates/${props.mandate.mandate_id}`
      )
      const status = computed(() => 
        Constants.mandates.statusDescription[props.mandate.status]
      )
      const scheme = computed(() =>
        Constants.mandates.scheme[props.mandate.scheme]
      )

      function toggleSelection () {
        context.emit('toggle-selection', props.mandate._id, !!props.isSelected)
      }

      watch(() => props.isSelected, newValue => {
        if (newValue != selected.value) {
          selected.value = !!newValue
        }
      })

      return {
        selected,
        toggleSelection,
        mandateUrl,
        status,
        scheme,
        ...useDate(),
      }
    }
  }
</script>


<style lang="scss">
  .mandate-list-item {
    padding: 0.45rem 1rem 0.45rem 1rem;
  }
</style>